/* eslint-disable */
import Header from "../../component/Header/Header";
import "../../App.css";
import SPLogin from "../IntermediarySelection/SPLogin";
import QPPOSLogin from "../IntermediarySelection/QPPOSLogin";
import EmployeeLogin from "../IntermediarySelection/EmployeeLogin";
import React,{ useEffect, useState } from "react";
import { encrypt, decryp } from "../../Constant/Encrypt";

function App() {
  const [paramsData, setParamsData] = useState();
  useEffect(() => {
    getQuery();
  }, []);
  const [intermedsubcatcd, setIntermedCategory] = useState("");
  const getQuery = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    var query = params.get("agentId");
    var key = "lv39eptlvuhaqqer";
    
    if (query == null) {
      return;
    }

    if (query != null) {
      var agentId = params.get("agentId");
      var intermedsubcatcd = params.get("category");
      var mobilenumber = params.get("mobilenumber");
      var authorization = params.get("authorization")?params.get("authorization"):false;
      var skip = params.get("skip")?params.get("skip"):true;
      var productName = params.get("productName")?params.get("productName"):"All Products";
      if (agentId !== null && intermedsubcatcd !== null) {
        var paramsData = {
          agentId: agentId,
          mobilenumber: mobilenumber,
          intermedsubcatcd: intermedsubcatcd,
          authorization: authorization,
          skip: skip,
          productName: productName
        };
        setParamsData(paramsData);
        setIntermedCategory(intermedsubcatcd);
      }
    }
  };
  const redirectPages = () => {
    switch(intermedsubcatcd) {
      case 'BROKER':
        return <QPPOSLogin paramsData={paramsData} />;
      case 'SP':
      case 'AGENT':  
      case 'IMF Broker Agent':
      case 'DUMMY':  
        return <SPLogin paramsData={paramsData} />;
      case 'EMPLOYEE':
        return <EmployeeLogin paramsData={paramsData} />;
      case 'POSP':
        return <EmployeeLogin paramsData={paramsData} />;
      default:  
      return '';
    };
    
    /*if (intermedsubcatcd == "BROKER") {
      return <QPPOSLogin paramsData={paramsData} />;
    } else if (
      intermedsubcatcd == "SP" ||
      intermedsubcatcd == "AGENT" ||
      intermedsubcatcd == "IMF Broker Agent" ||
      intermedsubcatcd == "DUMMY" ||
      intermedsubcatcd == "POSP"
    ) {
      return <SPLogin paramsData={paramsData} />;
    } else if (intermedsubcatcd == "EMPLOYEE") {
      return <EmployeeLogin paramsData={paramsData} />;
    }else if (intermedsubcatcd == "POSP") { 
      return <SPLogin paramsData={paramsData} />;
    }*/
  };
  return <>{intermedsubcatcd && redirectPages()}</>;
}

export default App;
